/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AffectsProductionReport/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function AffectsProductionReport({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/AddAction/Add/Content/AffectsProductionReport",
  onChange
  
}) {
let chargeAffectingProductionReportValueData = fromData.useDataValue({ viewPath,
context: 'charge',
path: 'affecting_production_report',
})
let chargeAffectingProductionReportChangeData = fromData.useDataChange({ viewPath,
context: 'charge',
path: 'affecting_production_report',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="charge.affecting_production_report"
 value={chargeAffectingProductionReportValueData}
 onChange={chargeAffectingProductionReportChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Affects production report"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}